export default "__VITE_ASSET__f3b6735e__"